import { React, useState, useEffect } from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";

function ValidateTextField(props) {
  const { value, setter, pattern, errorMessage, required, maxLength, isLoading } = props;
  const patternRegex = new RegExp(pattern);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!isLoading && required)
    {
      // Check if the field is required and the value is empty
      if (value.trim() === "") {
        setError(true);
      } else if (pattern && !patternRegex.test(value)) {
        // Check if there's a pattern and the value doesn't match it
        setError(true);
      } else {
        setError(false);
      }
    }
  }, [required, value, pattern, isLoading]);

  const handleChange = (event) => {
    if (event.target.value.length > maxLength) {
      setError(true);
      return;
    }
    setter(event.target.value);
    setError(false); // reset error when user changes input
  };

  const handleBlur = () => {
    if (value.trim() === "") {
      if (!required) {
        setError(false);
        return;
      }
      setError(true);
      return;
    }
    if (!patternRegex) {
      setError(false);
      return;
    }
    if (patternRegex.test(value) && value.length === value.match(patternRegex)[0].length) {
      setError(false);
      return;
    }
    setError(true);
  };

  return (
    <TextField className="ValidateTextField"
      size="small"
      type="text"
      required={required}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
      helperText={error ? errorMessage : ""}
      sx={{ width: 250 }}
      inputProps={{ maxLength: maxLength }}
    />
  );
}

ValidateTextField.propTypes = {
  value: PropTypes.string,
  setter: PropTypes.func,
  pattern: PropTypes.string,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  maxLength: PropTypes.number,
  isLoading: PropTypes.bool,
};

ValidateTextField.defaultProps = {
  value: "",
  setter: () => { },
  pattern: "",
  errorMessage: "",
  required: false,
  maxLength: 100,
  isLoading: false,
};

export default ValidateTextField;
